import React from "react";
import {  Button } from "@mui/material";
import { AboutDescription, AboutLetterHeadingText, AboutLetterLetterHeading, AboutLetterSection, AboutSection, AboutSubTitle, AboutTitle, AboutUsContainer } from "../../assets/styles/CommonStyles";


const AboutUs = () => {
  return (
    <AboutUsContainer>
      <AboutSection>
        <AboutTitle>VISION</AboutTitle>
        <AboutDescription>
          At iScreening, we believe safety is for everyone. Safety creates trust, and we want everyone to experience this feeling at all times.
        </AboutDescription>
      </AboutSection>

      <AboutSection>
        <AboutTitle>MISSION</AboutTitle>
        <AboutDescription>Our mission of Safety through Intelligence drives us every day, fuelling our passion to provide this to our clients. We are motivated by the knowledge that, somewhere, someone feels safer because of what we do. We make it happen through customised Intelligence that brings Safety to your fingertips.        </AboutDescription>
        <AboutDescription>Using Devia.ai, our intuitively intelligent platform, we source data from authentic sources - network of on-ground intelligence and verified sources, validate its accuracy, replenish it with our experience and give you actionable recommendations, Our mission is to also provide this in dynamic, customised dashboards updated regularly for easy and immediate decision making.</AboutDescription>
        <AboutDescription>We understand the responsibility that comes with people relying on our information to make decisions.This drives us to uphold the highest standards of integrity and trust.</AboutDescription>
        <AboutDescription>Our mission also goes beyond data—we aim to create an ecosystem and a community where opportunities are created for independent workers as well. Across the community and the ecosystem safety remains the paramount promise thereby creating Trust across businesses and their stakeholders.</AboutDescription>
      </AboutSection>

      <AboutSection>
        <AboutTitle>VALUES</AboutTitle>
      </AboutSection>

      <AboutSection>
        <AboutSubTitle>Customer First, Insight Always</AboutSubTitle>
        <AboutDescription>Every data point tells a story, and we are committed to translating these stories into meaningful insights. Whether you’re an individual, a business, or a large organization, we tailor our solutions to your unique needs. By leveraging advanced AI and real-time data analysis, we reduce verification time while ensuring the highest standards of accuracy and integrity—so you get the clarity you need, when you need it.</AboutDescription>
      </AboutSection>

      <AboutSection>
        <AboutSubTitle>Integrity Above All</AboutSubTitle>
       <AboutDescription>Speed means nothing without trust. At Devia, we don’t just verify information-we uphold truth, fairness, and transparency in every step of the process. Our commitment to integrity ensures that every report, every check, and every insight is delivered with authenticity, allowing businesses to make confident, ethical decisions.</AboutDescription>
      </AboutSection>

      <AboutSection>
        <AboutSubTitle>People Drive Our Purpose</AboutSubTitle>
        <AboutDescription>Our people are our greatest strength—the foundation of everything we do. We foster a culture of continuous learning, curiosity, and collaboration, empowering our team to push boundaries and innovate. While we may not have all the answers, we embrace every challenge as an opportunity to grow, learn, and evolve together.</AboutDescription>
      </AboutSection>

      <AboutSection>
        <AboutSubTitle>Diversity Fuels Innovation</AboutSubTitle>
       <AboutDescription>We believe that a truly inclusive ecosystem goes beyond rules-it embraces individuality, perspectives, and backgrounds. By honouring diverse voices and fostering an environment where everyone feels valued, we create a verification framework that reflects the rich fabric of society, making trust accessible to all.</AboutDescription>
      </AboutSection>

      <AboutSection>
        <AboutSubTitle>Solutions, Not Roadblocks</AboutSubTitle>
       <AboutDescription>Challenges don’t slow us down—they drive us forward. With a problem-solving mindset, we turn obstacles into opportunities, ensuring businesses and individuals navigate risks with confidence. Whether tackling complex verifications or adapting to industry shifts, we are relentless in finding the right solutions that empower trust, security, and growth.</AboutDescription>
      </AboutSection>

      <AboutSection>
        <AboutSubTitle>Intuitive Intelligence</AboutSubTitle>
       <AboutDescription>Combining human intuition and artificial intelligence, we recognise that relationships are at the core of every partnership – whether with stakeholders, partners or employees. The human factor is also woven into our analysis – the values, reputation and credibility of possible partners, employees alongside practical considerations. Moreover, with Devia.ai we provide speedy updates navigating intuitively changes and movements within existing partnerships.</AboutDescription>
      </AboutSection>

      <AboutLetterSection>
  <AboutLetterLetterHeading>
    <AboutLetterHeadingText>A Letter </AboutLetterHeadingText>
    <AboutLetterHeadingText>From CEO</AboutLetterHeadingText>
  </AboutLetterLetterHeading>
  <Button className="custom-button about-us-letter-btn" variant="contained">
    Click here to Read
  </Button>
</AboutLetterSection>

    </AboutUsContainer>
  );
};

export default AboutUs;
